module.exports = __webpack_public_path__ + "static/media/PM42.d984079d.JPG";